import React from 'react'

const RuleHistory = () => {
  return (
    <div>RuleHistory</div>
  )
}

export default RuleHistory